/**
 * OpenAPI definition
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserPreferencesResourceCriteriaInner } from './user-preferences-resource-criteria-inner';


/**
 * User preferences for units and criteria.
 */
export interface UserPreferencesResource { 
    /**
     * The preferred unit system.
     */
    unitSystem?: UserPreferencesResourceUnitSystemEnum;
    /**
     * Stored criteria.
     */
    criteria?: Array<UserPreferencesResourceCriteriaInner>;
}
export enum UserPreferencesResourceUnitSystemEnum {
    Metric = 'METRIC',
    Imperial = 'IMPERIAL'
};



